import type { ModuleDefinition, ModuleInfo, NavigationItem } from './types';

const modules: ModuleDefinition[] = [];

export const registeredModules = modules;

export const registerModule = (module: ModuleDefinition) => {
  const exists = modules.some((m) => m.name === module.name);
  if (!exists) {
    modules.push(module);
  }
};

export const getModule = (name: string) => modules.find((module) => module.name === name);

export const getNavigation = (): NavigationItem[] =>
  modules.flatMap((module) => module.navigation ?? []);

/**
 * Get navigation items for a specific module
 */
export const getModuleNavigation = (moduleName: string): NavigationItem[] => {
  const module = getModule(moduleName);
  return module?.navigation ?? [];
};

/**
 * Get all module info for the module selector
 * Returns modules sorted by their order
 */
export const getModuleInfoList = (): ModuleInfo[] =>
  modules
    .filter((m) => m.moduleInfo)
    .map((m) => m.moduleInfo!)
    .sort((a, b) => (a.order ?? 100) - (b.order ?? 100));

/**
 * Get module by its base path
 */
export const getModuleByPath = (path: string): ModuleDefinition | undefined => {
  // Normalize the path to match the basePath format
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return modules.find((m) => normalizedPath.startsWith(m.basePath));
};
